export enum AuthRole {
    IsSuperAdmin = 1,

    NkrAccessBilling = 10,
    NkrAccessCenter = 20,
    NkrAccessDonorConnect = 30,
    NkrAccessSwaps = 40,
    NkrAccessOperations = 50,
    NkrAccessReports = 60,
    NkrAccessWatr = 70,
    NkrAccessIlda= 80,

    CenterAccessAll = 100,
    CenterAccessBilling = 110,
    CenterAccessDash = 120,
    CenterAccessFollowUp = 130,
    CenterAccessKpd = 140,
    CenterAccessMicrosite = 150,
    CenterAccessSettings = 160,
    CenterAccessUsers = 170,
    CenterAccessWatr = 180,

    DonorConnectAccessAll = 200,
    DonorConnectAccessAssigned = 210,
    DonorConnectAccessReports = 220,

    IldaAccessAll = 300

}